export default {
  mainContext: [
    'We don’t just offer a full-time office-based job where your only motivation to meet the deliverables will be the monthly paycheck. Working at STATECS is about challenges and doing something meaningful. Something that can actually have a global impact. Haven’t you ever felt the urge to change the world? Well, STATECS gives you the opportunity to have your share in the improvement of the global healthcare system and patient safety.',
    'Join our team of motivated, smart, and ambitious people - a fun and friendly environment is guaranteed. ',
  ],
  employeesOptions: [
    {
      fullName: 'Emma Galstyan',
      position: 'Mid-Level Statistical Programmer',
      opinion: 'What I love about STATECS is how helpful everyone is. The people here have helped me acquire a lot of new skills and knowledge and I can’t be thankful enough.',
      imgSrc: '/assets/images/team/employees/emma.svg',
    },
    {
      fullName: 'Lusine Barseghyan',
      position: 'Senior Statistical Programmer',
      opinion: 'I love working at STATECS. It’s such a challenge and pleasure to work in a place where you know the results of what you do will help other people out there.',
      imgSrc: '/assets/images/team/employees/lusine.svg',
    },
    {
      fullName: 'Syuzanna Zaqaryan',
      position: 'Statistical Programmer',
      opinion: 'I have never been a tech person but at STATECS I started loving everything related to technology and now I just want to learn more and enrich my experience so as to help our company achieve new milestones.',
      imgSrc: '/assets/images/team/employees/syuzanna.svg',
    },
    {
      fullName: 'Erik Torosyan',
      position: 'Senior Statistical Programmer',
      opinion: 'What I value here is the mutual trust between all our colleagues. That trust then expands to form the basis of collaboration with our clients. I believe that the trust toward the person you have hired to do certain tasks is very important in the results you will get in the future.',
      imgSrc: '/assets/images/team/employees/erik.svg',
    },
  ],
};
